import React from 'react'
import { deleteCookie } from '@chilecompra/react-kit'
import { PUBLIC_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import MenuTransversal from './MenuTransversal.container'
import { BackButton, Container, Item, Logo, LogoLink, Root } from './Header.styles'

/**
 * The Header's container.
 */
const Header = () => {
  const handleClickHome = (event, isPrivate) => {
    event.preventDefault()
    deleteCookie('access_token')
    if (isPrivate) {
      window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`, '_top')
      return
    }
    location.href = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`
  }

  return (
    <Root>
      <MenuTransversal />
      <Container direction="row" justifyContent="flex-start">
        <Item width="auto">
          <LogoLink
            href={`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`}
            target="_top"
            aria-label="Ir al sitio de Mercado Público"
          >
            <Logo alt="Logo Chile compra" src={`${PUBLIC_URL}/assets/images/logo_mercadopublico.svg`} />
          </LogoLink>
        </Item>
        <Item width="auto">
          <BackButton
            margin="10px 0 0 0"
            onClick={event => handleClickHome(event)}
            tabIndex="0"
            aria-label="Volver atrás"
          >
            Volver al inicio
          </BackButton>
        </Item>
      </Container>
    </Root>
  )
}

export default Header
